const faqItems = [
  {
    q: '爱漫画上的漫画都是免费的吗？',
    a: '是的，非常爱漫画平台上的所有漫画内容均免费提供给读者阅读。无需注册登录、无需购买会员、无需充值，打开网页即可开始阅读，真正做到零门槛畅享漫画世界。',
  },
  {
    q: '什么是下拉式阅读？和翻页有什么不同？',
    a: '下拉式阅读是一种新型漫画阅读方式，内容以纵向长图形式呈现，读者只需向下滑动屏幕即可持续阅读，无需点击翻页按钮。相比传统翻页模式，下拉式阅读更加连贯流畅，减少了翻页等待时间，特别适合手机阅读场景。',
  },
  {
    q: '爱漫画支持哪些设备阅读？',
    a: '非常爱漫画全面适配电脑、平板和手机等各类设备。在手机上使用浏览器访问即可获得优化的移动端阅读体验，无需额外下载APP。建议使用Chrome、Safari等主流浏览器获得最佳阅读效果。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们坚持每日同步更新策略，与各大漫画平台的更新节奏保持一致。热门连载作品通常在上线后1-2小时内即可在非常爱漫画阅读。部分人气作品的特别篇和番外内容也会在第一时间收录。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '您可以通过首页的专题合集按分类浏览，或使用热门榜单发现当前最受欢迎的漫画作品。我们还提供了热门话题标签帮助您快速定位感兴趣的内容类型。未来我们将上线搜索功能，让找漫画更加方便。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm text-foreground-500">关于爱漫画你想知道的一切</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:scale-[1.01] transition-transform cursor-pointer"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-800 mb-2 flex items-center gap-2">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xs font-bold flex-shrink-0">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-8">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}